import React, { useEffect, useState } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import { useSelector, connect } from "react-redux";
import { toast } from "react-toastify";
import { LocalStorageService, toAbsoluteUrl } from "../../../services";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  NumberFilterTypes,
  TextFilterTypes,
  operatorData,
  DateFilterTypes,
  customView,
  GendarFilterTypes,
  LockStatusLockType,
} from "./data";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DateRangePicker } from "../../components";

// get step data from redux main state
const data = (state) => state.nrpLeaderboard;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const CustomFilter = (props) => {
  let { campaginData, defaultAllColumn } = useSelector(data);
  // State for
  const [headers, setHeaders] = useState([]);
  const [filterData, setFilterData] = useState([
    {
      columnName: "",
      columnType: "text",
      type: "",
      value: "",
      conditionOp: "and",
    },
  ]);
  const [startDate, setstartDate] = useState("2010-01-02");
  const [endDate, setendDate] = useState(new Date());

  const addFilter = (indexOfCurrentItem) => {
    let myData = {
      columnName: "",
      columnType: "text",
      type: "",
      value: "",
      conditionOp: "or",
    };
    const data = [...filterData];
    console.log(data.splice(indexOfCurrentItem + 1, 0, myData));
    setFilterData(data);
    setFilterData([...filterData, myData]);
  };
  const removeFilter = (indexOfItem) => {
    const data = filterData.filter((item) => item !== filterData[indexOfItem]);
    // console.log("filter",filterData.indexOf(indexOf))

    setFilterData(data);
  };
  // handel Field
  const handelFieldChange = (event, i) => {
    const {
      target: { value },
    } = event;

    let check = filterData[i];
    check.columnName = value;
    check.value = "";
    check.type = "";
    filterData.splice(i, 1, check);
    setFilterData([...filterData]);
  };
  //   handel Filter
  const handelFilterChange = (event, i) => {
    const {
      target: { value },
    } = event;
    let check = filterData[i];
    check.type = value;
    filterData.splice(i, 1, check);
    setFilterData([...filterData]);
  };
  //   handel Filter Value
  const handelFilterValueChange = (event, i) => {
    const {
      target: { value },
    } = event;
    let check = filterData[i];
    check.value = value;
    filterData.splice(i, 1, check);
    setFilterData([...filterData]);
  };
  //   handel OPR Value
  const handelOptChange = (event, i) => {
    const {
      target: { value },
    } = event;
    let check = filterData[i];
    check.conditionOp = value;
    filterData.splice(i, 1, check);
    setFilterData([...filterData]);
  };
  //   Submit Filter Handler
  let submit = () => {
    let allData = [];
    for (let i = 0; i < filterData.length; i++) {
      const singleFilter = filterData[i];
      let { columnName, columnType, type, value } = singleFilter;
      if (!columnName || !columnType || !type || !value) {
        toast("Invalid Filter Added!", {
          position: "bottom-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        break;
      } else {
        allData.push(singleFilter);
      }
    }
    if (allData.length === filterData.length) {
      LocalStorageService.setObject("filter", filterData);
      allData.forEach((filter, i) => {
        if (i != allData.length - 1)
          allData[i]["conditionOp"] = allData[i + 1]["conditionOp"];
      });
      // console.log(allData,' here is final data')

      props.getFilterQueries(allData);
      props.handelNo();
    }
  };
  // Clear All Filters
  let clearAllFilters = () => {
    LocalStorageService.remove("filter");
    setFilterData([
      {
        columnName: "",
        columnType: "text",
        type: "",
        value: "",
        conditionOp: "or",
      },
    ]);
    props.getFilterQueries([]);
    props.handelNo();
  };
  useEffect(() => {
    let savedData = LocalStorageService.getObject("filter");
    let isSaved = Object.keys(savedData).length > 0;
    if (isSaved) {
      setFilterData(savedData);
    }
    if (campaginData) {
      let assessmentMenu = props.assessmentMenu;
      console.log(assessmentMenu);
      let myFinalData = [];
      Object.keys(customView).forEach((cel) => {
        customView[cel].forEach((el) => {
          defaultAllColumn.forEach((del) => {
            if (el.field == del.title) {
              del.headerName = el.headerName;
              myFinalData.push(del);
            }
          });
        });
      });
      setHeaders(myFinalData);
    }
  }, [campaginData]);
  
  useEffect(() => {
    if (props.campaign) {
      let { createdAt } = props.campaign;
      setstartDate(createdAt);
    }
  }, [props]);
  
  return (
    <div>
      <div className="bg-[#007E8C] px-2 py-3 flex flow-row items-center justify-between">
        <div className="flex items-center ">
          <img
            src={toAbsoluteUrl("/media/nrp/leaderboard/filterIcon.png")}
            alt="Export"
            style={{
              width: 15,
              height: 15,
              marginRight: 10,
            }}
          />
          <h3 className="text-[#FFFFFF] ml-2 font-semibold ">Custom Filter</h3>
        </div>
        <XCircleIcon
          onClick={() => {
            props.handelNo();
          }}
          className="w-7 h-7 cursor-pointer "
          color="white"
        />
      </div>
      <div className="px-2 py-6">
        {filterData &&
          filterData.map((item, i) => {
            return (
              <div key={i}>
                {item.conditionOp && i > 0 ? (
                  <div className="ml-2">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      {operatorData.map((opt, p) => {
                        return (
                          <FormControlLabel
                            onChange={(e) => handelOptChange(e, i)}
                            key={p}
                            value={opt.key}
                            control={
                              <Radio
                                checked={
                                  item.conditionOp == opt.key ? true : false
                                }
                              />
                            }
                            label={
                              opt.name.charAt(0).toUpperCase() +
                              opt.name
                                .slice(1)
                                .replace(/([A-Z])/g, " $1")
                                .trim()
                            }
                          />
                        );
                      })}
                    </RadioGroup>
                  </div>
                ) : null}
                <div className="flex flex-row justify-between">
                  <div style={{ width: "29%" }}>
                    <FormControl sx={{ m: 1, width: 160 }}>
                      <InputLabel id="demo-multiple-name-label">
                        Field
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        value={item.columnName}
                        input={<OutlinedInput label="Name" />}
                        onChange={(e) => handelFieldChange(e, i)}
                        MenuProps={MenuProps}
                      >
                        {headers.map((list, j) => (
                          <MenuItem
                            onClick={() => {
                              let check = filterData[i];
                              check.columnType = list.fieldType;
                              filterData.splice(i, 1, check);
                              setFilterData([...filterData]);
                            }}
                            key={j}
                            value={list.title}
                          >
                            {list.headerName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "29%" }}>
                    <FormControl sx={{ m: 1, width: 160 }}>
                      <InputLabel id="demo-multiple-name-label">
                        Filter
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        value={item.type}
                        input={<OutlinedInput label="Filter" />}
                        onChange={(e) => handelFilterChange(e, i)}
                        MenuProps={MenuProps}
                      >
                        {item.columnName === "gender"
                          ? GendarFilterTypes.map((item, i) => (
                              <MenuItem key={i} value={item.key}>
                                {item.name}
                              </MenuItem>
                            ))
                          : item.columnName === "userLockStatus" ||
                            item.columnName === "userLockType"
                          ? LockStatusLockType.map((item, i) => (
                              <MenuItem key={i} value={item.key}>
                                {item.name}
                              </MenuItem>
                            ))
                          : item.columnType === "number"
                          ? NumberFilterTypes.map((item, i) => (
                              <MenuItem key={i} value={item.key}>
                                {item.name}
                              </MenuItem>
                            ))
                          : item.columnType === "date"
                          ? DateFilterTypes.map((item, i) => (
                              <MenuItem key={i} value={item.key}>
                                {item.name}
                              </MenuItem>
                            ))
                          : TextFilterTypes.map((item, i) => (
                              <MenuItem key={i} value={item.key}>
                                {item.name}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "29%" }}>
                    {item.columnName === "gender" ? (
                      <FormControl sx={{ m: 1, width: 160 }}>
                        <InputLabel id="demo-multiple-name-label">
                          Value
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          value={item.value}
                          input={<OutlinedInput label="Value" />}
                          onChange={(e) => handelFilterValueChange(e, i)}
                          MenuProps={MenuProps}
                        >
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Memale">Female</MenuItem>
                        </Select>
                      </FormControl>
                    ) : item.columnName === "userLockType" ? (
                      <FormControl sx={{ m: 1, width: 160 }}>
                        <InputLabel id="demo-multiple-name-label">
                          Value
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          value={item.value}
                          input={<OutlinedInput label="Value" />}
                          onChange={(e) => handelFilterValueChange(e, i)}
                          MenuProps={MenuProps}
                        >
                          <MenuItem value="Session">Session</MenuItem>
                          <MenuItem value="Tab">Tab</MenuItem>
                        </Select>
                      </FormControl>
                    ) : item.columnName === "userLockStatus" ? (
                      <FormControl sx={{ m: 1, width: 160 }}>
                        <InputLabel id="demo-multiple-name-label">
                          Value
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          value={item.value}
                          input={<OutlinedInput label="Value" />}
                          onChange={(e) => handelFilterValueChange(e, i)}
                          MenuProps={MenuProps}
                        >
                          <MenuItem value={"t"}>True</MenuItem>
                          <MenuItem value={"f"}>False</MenuItem>
                        </Select>
                      </FormControl>
                    ) : item.columnName === "healthDisability" ? (
                      <FormControl sx={{ m: 1, width: 160 }}>
                        <InputLabel id="demo-multiple-name-label">
                          Value
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          value={item.value}
                          input={<OutlinedInput label="Value" />}
                          onChange={(e) => handelFilterValueChange(e, i)}
                          MenuProps={MenuProps}
                        >
                          <MenuItem value={"No"}>No</MenuItem>
                          <MenuItem value={"Yes"}>Yes</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <TextField
                        id="demo-multiple-name"
                        label=""
                        value={item.value}
                        type={item.columnType}
                        onChange={(e) => handelFilterValueChange(e, i)}
                        style={{ marginTop: 8 }}
                        variant="outlined"
                        placeholder="Your Query here .."
                      />
                    )}
                  </div>

                  <div style={{ width: "5%" }} className="px-[2px]">
                    <FaPlusCircle
                      className="w-6 h-6  text-[#007E8C] my-6"
                      onClick={() => addFilter(i)}
                    />
                  </div>
                  <div style={{ width: "5%" }} className="px-[2px]">
                    {(i > 0 || filterData.length > 1) && (
                      <FaMinusCircle
                        className="w-6 h-6  text-[#007E8C] my-6"
                        onClick={() => removeFilter(i)}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="absolute bottom-2 w-full px-4 pb-6 flex flex-row justify-between">
        <button
          onClick={clearAllFilters}
          className={`text-[white] bg-[#007E8C] w-[10rem] font-medium rounded-md text-sm px-5 py-2.5 text-center flex flex-row justify-center items-center`}
        >
          Clear All Filters
        </button>
        <button
          onClick={submit}
          className="text-[white] bg-[#007E8C] w-[10rem] font-medium rounded-md text-sm px-5 py-2.5 text-center flex flex-row justify-center items-center "
        >
          Submit
        </button>
      </div>
    </div>
  );
};
const mapStateToProps = ({ state }) => ({
  state,
});
export default connect(mapStateToProps, {})(CustomFilter);
